import React from "react";
import { SentIcon } from "hugeicons-react";
import type { ChatInputProps } from "../types";

export const ChatInput: React.FC<ChatInputProps> = ({
  inputText,
  setInputText,
  onSubmit,
  disabled = false,
  isAuthenticating = false,
  showCommandMenu = false,
  availableCommands = [],
  onCommandSelect,
  onKeyDown,
  selectedCommandIndex = 0,
}) => {
  return (
    <div className="chat-input-wrapper">
      {showCommandMenu && availableCommands.length > 0 && (
        <div className="command-menu">
          <div className="command-menu-header">Available Commands</div>
          {availableCommands.map((cmd, index) => (
            <div
              key={cmd.name}
              className={`command-item ${index === selectedCommandIndex ? "command-item-selected" : ""}`}
              onClick={() => onCommandSelect?.(cmd.name)}
            >
              <span className="command-name">/{cmd.name}</span>
              <span className="command-description">{cmd.description}</span>
            </div>
          ))}
        </div>
      )}
      <form className="chat-input-container" onSubmit={onSubmit}>
        <input
          type="text"
          className="chat-input"
          placeholder={
            isAuthenticating
              ? "Authenticating..."
              : "Type your message or / for commands..."
          }
          value={inputText}
          onChange={(e) => setInputText(e.target.value)}
          onKeyDown={onKeyDown}
          disabled={disabled || isAuthenticating}
        />
        <button
          type="submit"
          className="chat-send-button"
          disabled={disabled || isAuthenticating}
        >
          <SentIcon size={24} color="white" />
        </button>
      </form>
    </div>
  );
};
